import { render, staticRenderFns } from "./IntegralRuleEdit.vue?vue&type=template&id=04cdff42&"
import script from "./IntegralRuleEdit.vue?vue&type=script&lang=js&"
export * from "./IntegralRuleEdit.vue?vue&type=script&lang=js&"
import style0 from "./IntegralRuleEdit.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports